export default class api{

    static async json( $path , $data ){
        try{
            let response = await fetch(
                $path ,
                {
                    method : 'POST' ,
                    headers : {
                        'Content-Type' : 'application/json;charset=utf-8' ,
                    } ,
                    body : JSON.stringify( $data )
                }
            );

            return await response.json();
        }catch( e ){
            console.error( e.message );
        }
    }

    static async form( $path , $data ){
        try{
            const formData = new FormData();

            for( let i in $data ){
                if( $data[ i ] instanceof FileList ){
                    continue;
                }

                if( $data[ i ] ){
                    formData.append( i , $data[ i ] );
                }
            }

            let response = await fetch(
                $path ,
                {
                    method : 'POST' ,
                    headers : {} ,
                    body : formData
                }
            );

            return await response.json();

        }catch( e ){
            return { error : e.message }
        }
    }

    static async upload( $url , $input ){
        try{
            const formData = new FormData();

            for( const file of $input.files ){
                formData.append( 'image' , file , file.name )
            }

            // for( let i in $data ){
            //     if( $data[ i ] instanceof FileList ){
            //         Array.from( $data[ i ] ).forEach( item => formData.append( i + '[]' , item ) )
            //     }
            // }

            let response = await fetch(
                $url ,
                {
                    method : 'POST' ,
                    headers : {} ,
                    body : formData
                }
            );

            return await response.json();

        }catch( e ){
            return { error : e.message }
        }
    }

    static getUrlParams(){
        let searchParams = new URLSearchParams( document.location.search );
        let res = {};
        for( let pair of searchParams.entries() ){
            res[ pair[ 0 ] ] = pair[ 1 ];
        }
        return res;
    }
}
